import { useState } from 'react';

import {
  AssignmentStatus,
  DesmosAssignment,
  SingleAssignment,
} from 'src/interfaces/assignment.types';
import authService from 'src/services/api/auth.service';
import { loggerService } from 'src/services/logger.service';
import { useUpdateK5AssignmentStatusMutation } from 'src/store/api/assignment';

const useAssignmentToggle = (
  assignment: SingleAssignment | DesmosAssignment | undefined,
) => {
  const [status, setStatus] = useState(assignment?.status);
  const [mutateK5AssignmentStatus] = useUpdateK5AssignmentStatusMutation();

  const toggleStatus = () => {
    if (!assignment) return;

    const prevStatus = status;

    const hasPastWorkStatus =
      status === AssignmentStatus.READ || status === AssignmentStatus.STARTED;

    const newStatus = hasPastWorkStatus
      ? AssignmentStatus.TODO
      : AssignmentStatus.READ;

    setStatus(newStatus);

    mutateK5AssignmentStatus({
      studentBusinessKey: authService.getUserBk(),
      assignmentBusinessKey: assignment.assignmentBk,
      status: newStatus,
      contentStatuses: [
        {
          status: newStatus,
          contentBusinessKey: assignment.contentBk,
        },
      ],
    })
      .unwrap()
      .catch((e) => {
        loggerService.logError(e);
        setStatus(prevStatus);
      });
  };

  return { status, toggleStatus };
};

export default useAssignmentToggle;
